// extracted by mini-css-extract-plugin
export default {"Haricot":"#01A92B","White":"#FFFFFF","ScreenXSMax":"(max-width: 767px)","discountBadge":"G76a260 G4430ba","discountCopy":"Gedbbc6 G841166"};